// extracted by mini-css-extract-plugin
export default {"toggle":"switch-local__toggle___V2tiQajb","toggle__switch":"switch-local__toggle__switch___Cbqx-KBY"};